module.exports = __webpack_public_path__ + "img/prot-40000.873fd6ab.png";